<template>
    <div>
        <section class="section">
            <div class="container">
                <div class="columns marginless has-text-centered">
                    <div class="column"><h1 class="title is-red">Contact us</h1></div>
                </div>
                <div class="columns marginless has-text-centered-mobile" v-bind:style="{ 'margin-top' : '30px' }">
                    <div class="column is-6">
                       <p><span class="is-red">Exito Group Co.,Ltd</span><br>
                       1 Empire Tower Floor 47 Room 4703,<br>
                       South Sathorn Rd., Yannawa, Sathorn<br>
                       Bangkok 10120, Thailand</p>
                       <p>
                           Tel : <a href="tel:+66850993971">+66 (0) 85 099 3971</a><br>
                           Email : <a href="mailto:prinz@exitogroup.co.th">prinz@exitogroup.co.th</a><br>
                       </p>
                    </div>
                    <div class="column is-6">
                        <iframe title="Exito Group Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.9695115760524!2d100.52785695077067!3d13.720295690320597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f322b611def%3A0xd61a0ea672e4c2b!2z4LmA4Lit4LmH4Lih4LmE4Lie4Lij4LmM4LiX4Liy4Lin4LmA4Lin4Lit4Lij4LmMIOC5geC4guC4p-C4hyDguKLguLLguJnguJnguLLguKfguLIg4LmA4LiC4LiVIOC4quC4suC4l-C4oyDguIHguKPguLjguIfguYDguJfguJ7guKHguKvguLLguJnguITguKMgMTAxMjA!5e0!3m2!1sth!2sth!4v1560956552220!5m2!1sth!2sth" width="100%" frameborder="0" style="border:0;height:450px;" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>

<script>
   
    export default {
        name: "Contact",
        
        data: function () {
            return {
                //image: require('../../public/img/bg.jpg'),
                
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a {
        color:#D63B2F;
    }
    .border-r {
        border-radius: 15px;
    }
    .is-red{
        color:#D63B2F;
    }
</style>
